import qs from "querystring";

import { ApiClient } from "./api-client";
import type {
    GetSavedSearchesResponse,
    PaginationRequestParams,
    RenameSearchParams,
    SaveSearchesParams,
    SavedSearchWithMeta,
    UserContextId,
} from "./types";

export default class SavedSearchesClient extends ApiClient {
    constructor({ baseURL, useEnv }: { baseURL?: string; useEnv?: boolean }) {
        super({
            baseURL,
            useEnv,
            apiPrefix: "saved-searches",
        });
    }

    async getByUserContextId({
        userContextId,
        ...params
    }: UserContextId & PaginationRequestParams): Promise<GetSavedSearchesResponse> {
        const paramsStr = qs.stringify(params);

        return super.makeGetRequest<GetSavedSearchesResponse>(`/${userContextId}?${paramsStr}`);
    }

    async saveSearches({
        userContextId,
        searches,
    }: SaveSearchesParams): Promise<SavedSearchWithMeta[]> {
        return super.makePostRequest<any>(`/${userContextId}`, searches);
    }

    async renameSearch({
        userContextId,
        searchId,
        name,
    }: RenameSearchParams): Promise<SavedSearchWithMeta> {
        return super.makePatchRequest(`/${userContextId}/${searchId}`, { name });
    }

    async deleteSearchById({
        userContextId,
        searchId,
    }: UserContextId & { searchId: string }): Promise<void> {
        return super.makeDeleteRequest(`/${userContextId}/${searchId}`);
    }

    async deleteAll({ userContextId }: UserContextId): Promise<void> {
        return super.makeDeleteRequest(`/${userContextId}`);
    }
}
